import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ba5bd90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  id: "center",
  class: "center-wrapper"
}
const _hoisted_4 = {
  id: "center-content",
  class: "center-content"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "앱을 "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "종료"),
  /*#__PURE__*/_createElementVNode("span", null, "하시겠습니까?")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", { ios: $setup.isiOS }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["left-wrapper", [$setup.layoutMode]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: $setup.logoPath,
          alt: "logo"
        }, null, 8 /* PROPS */, _hoisted_2)
      ]),
      _createVNode($setup["CompanyInfo"], {
        class: "company-info-wrapper",
        termsList: $setup.termsList,
        onOnClickTerms: $setup.showTermsOnNewWindow
      }, null, 8 /* PROPS */, ["termsList"])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($setup.isReadyForService)
          ? (_openBlock(), _createBlock(_component_router_view, {
              key: $setup.updateKey,
              isColsedNoticeModal: $setup.isColsedNoticeModal,
              onShowNoticeModal: $setup.showNoticeModal
            }, {
              default: _withCtx(({ Component, route }) => [
                _createVNode(_Transition, {
                  name: route.meta.transitionName
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_KeepAlive, {
                      include: route.meta.keepAliveList
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { onVnodeBeforeUnmount: $setup.resetZoom }, null, 512 /* NEED_PATCH */))
                    ], 1032 /* PROPS, DYNAMIC_SLOTS */, ["include"]))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["name"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["isColsedNoticeModal"]))
          : _createCommentVNode("v-if", true),
        ($setup.shouldShowErrorModal)
          ? (_openBlock(), _createBlock($setup["ErrorModal"], {
              key: 1,
              title: $setup.errorTitle,
              errorMessage: $setup.errorMessage,
              errorCode: $setup.errorCode,
              errorTime: $setup.errorTime,
              onOnClickConfirmButton: $setup.hideErrorModal
            }, null, 8 /* PROPS */, ["title", "errorMessage", "errorCode", "errorTime"]))
          : _createCommentVNode("v-if", true),
        ($setup.shouldShowToast)
          ? (_openBlock(), _createBlock($setup["ToastMessage"], {
              key: $setup.toastUpdateKey,
              message: $setup.toastMessage,
              durationMillis: $setup.toastDuration,
              delayMillis: $setup.toastDelay
            }, null, 8 /* PROPS */, ["message", "durationMillis", "delayMillis"]))
          : _createCommentVNode("v-if", true),
        ($setup.shouldShowFinishAppModal)
          ? (_openBlock(), _createBlock($setup["Modal"], {
              key: 3,
              title: "알림",
              okButtonTitle: "예",
              cancelButtonTitle: "아니오",
              onOnClickOkButton: $setup.finishApp,
              onOnClickCancelButton: _cache[0] || (_cache[0] = ($event: any) => ($setup.shouldShowFinishAppModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        ($setup.shouldShowNotice)
          ? (_openBlock(), _createBlock($setup["NoticeModal"], {
              key: 4,
              noticeInfos: $setup.popupNoticeInfos,
              onOnClose: $setup.onCloseNoticeModal
            }, null, 8 /* PROPS */, ["noticeInfos"]))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createVNode($setup["LoadingView"], null, null, 512 /* NEED_PATCH */), [
          [_vShow, $setup.shouldShowLoadingImage]
        ]),
        _createVNode(_Transition, {
          appear: "",
          name: "slide-up"
        }, {
          default: _withCtx(() => [
            ($setup.shouldShowAppPermissionsModal)
              ? (_openBlock(), _createBlock($setup["AppPermissionsModal"], {
                  key: 0,
                  permissions: $setup.targetPermissions,
                  onOnClosedModal: $setup.onClosedAppPermissionsModal
                }, null, 8 /* PROPS */, ["permissions"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" 비밀번호 만료 전, 변경 안내 팝업 "),
        ($setup.shouldShowPasswordUpdateAlertModal)
          ? (_openBlock(), _createBlock($setup["Modal"], {
              key: 5,
              title: "비밀번호 변경 안내",
              okButtonTitle: "지금 변경하기",
              cancelButtonTitle: 
            $setup.canExtendPasswordExpiration ? '다음에 변경하기' : '닫기'
          ,
              onOnClickOkButton: $setup.handleClickPasswordUpdateOkButton,
              onOnClickCancelButton: $setup.onClickPasswordNextChangeButton
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, " 비밀번호를 변경한지 곧 " + _toDisplayString($setup.passwordChangeCycleDays) + "일이 됩니다. 개인정보 보호를 위해 미리 비밀번호를 변경해 주세요. ", 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["cancelButtonTitle"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["right-wrapper", [$setup.layoutMode]])
    }, null, 2 /* CLASS */),
    _createCommentVNode(" <div ref=\"floatingWrapper\" class=\"floating-icon-wrapper\">\n      <ZoomControl v-show=\"shouldShowZoomControl\" ref=\"zoomControl\" />\n    </div> ")
  ], 2 /* CLASS */))
}